import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: inherit;\n  outline: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import Box from "../layout/Box";
var FocusTrap = styled(Box).attrs(function(param) {
    var _as = param.as, as = _as === void 0 ? "div" : _as;
    return {
        tabIndex: -1,
        as: as,
        className: "focus-trap"
    };
}).withConfig({
    componentId: "sc-15bf3ddb-0"
})(_templateObject());
FocusTrap.displayName = "FocusTrap";
export default FocusTrap;
